import React from 'react'
import { t } from '../../translation/index'
import { Link } from 'react-router-dom'
import { format } from 'date-fns'
import Spinner from 'components/ui/Spinner/Spinner'

const AccountBlock = ({
  title,
  formEl,
  cancelSubscription,
  reactiveSubscription,
  formButton,
  link,
  card,
  payList,
  subscriptionHandler,
  loadingButton,
}) => {
  return (
    <div className="account_block">
      <div className="account_title">{title}</div>
      {formEl && (
        <div className="account_form">
          <div className="account_form_controller">
            <Link to={t(`links.CHANGE_PASSWORD`)} className="btn_v2">
              {formButton}
            </Link>
          </div>
        </div>
      )}
      {link && (
        <div className="account_content card_mod">
          <Link to={link} className="btn_v2">
            {formButton}
          </Link>
        </div>
      )}
      {cancelSubscription && (
        <div className="account_content card_mod">
          {loadingButton ? (
            <div className="btn_v2">
              <Spinner className="spinner_button" />
            </div>
          ) : (
            <button className="btn_v2" onClick={subscriptionHandler}>
              {formButton}
            </button>
          )}
        </div>
      )}
      {reactiveSubscription && (
        <div className="account_content card_mod">
          {loadingButton ? (
            <div className="btn_v2">
              <Spinner className="spinner_button" />
            </div>
          ) : (
            <button className="btn_v2" onClick={subscriptionHandler}>
              {formButton}
            </button>
          )}
        </div>
      )}
      {card && (
        <div className="account_content card_mod">
          <div className="account_content_col">
            <div className="account_list_title v2_mod">{card.name}</div>
            <div className="account_list_title v2_mod">{card.card}</div>
          </div>
          <div className="account_content_col">
            <Link to={t('links.CHANGE_CARD')} className="account_content_link">
              {card.title}
            </Link>
          </div>
        </div>
      )}
      {payList && (
        <div className="account_content">
          <ul className="account_list">
            {payList.map(({ createdAt, amount, currency }) => {
              return (
                <li className="account_list_item" key={createdAt}>
                  <div className="account_list_title">
                    {format(
                      new Date(createdAt * 1000),
                      `${currency.toUpperCase() === 'USD' ? 'MM/dd/yy' : 'dd/MM/yy'}`
                    )}
                  </div>
                  <div className="account_list_title">{`${
                    currency.toUpperCase() === 'USD' ? '$' : '€'
                  }${amount / 100}`}</div>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}

export default AccountBlock
